import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const API = process.env.REACT_APP_API_URL || 'http://45.236.131.39:4000';
const ADMIN_EMAIL = 'pedro.salfatte@techbrain.cl';

function formatTiempo(ts) {
  if (!ts) return '';
  try {
    const diff = Math.floor((Date.now() - new Date(ts)) / 60000);
    if (diff < 1) return 'ahora';
    if (diff < 60) return `hace ${diff} min`;
    const h = Math.floor(diff / 60);
    return `hace ${h} hr${h > 1 ? 's' : ''}`;
  } catch { return ''; }
}

const TIPO_CONFIG = {
  login:             { icon: '→',  color: '#6B7280', bg: 'rgba(107,114,128,0.1)' },
  registro:          { icon: '+',  color: '#1A6BFF', bg: 'rgba(26,107,255,0.1)' },
  desafio_creado:    { icon: '⚡', color: '#F59E0B', bg: 'rgba(245,158,11,0.1)' },
  desafio_aceptado:  { icon: '✓',  color: '#16A34A', bg: 'rgba(22,163,74,0.1)' },
  desafio_rechazado: { icon: '✗',  color: '#EF4444', bg: 'rgba(239,68,68,0.1)' },
  desafio_cancelado: { icon: '✗',  color: '#EF4444', bg: 'rgba(239,68,68,0.1)' },
  desafio_expirado:  { icon: '⏰', color: '#F59E0B', bg: 'rgba(245,158,11,0.1)' },
  resultado:         { icon: '⚽', color: '#16A34A', bg: 'rgba(22,163,74,0.1)' },
  elo_actualizado:   { icon: '▲',  color: '#1A6BFF', bg: 'rgba(26,107,255,0.1)' },
  evaluacion:        { icon: '★',  color: '#F59E0B', bg: 'rgba(245,158,11,0.1)' },
  arbitro_tomo:      { icon: '◈',  color: '#7C3AED', bg: 'rgba(124,58,237,0.1)' },
  recinto_nuevo:     { icon: '🏟', color: '#1A6BFF', bg: 'rgba(26,107,255,0.1)' },
  convocatoria:      { icon: '📣', color: '#6B7280', bg: 'rgba(107,114,128,0.1)' },
  perfil_editado:    { icon: '✏',  color: '#6B7280', bg: 'rgba(107,114,128,0.1)' },
  jugador_agregado:  { icon: '+',  color: '#16A34A', bg: 'rgba(22,163,74,0.1)' },
};

const NIVEL_COLORS = {
  urgente: { border: '#FCA5A5', bg: '#FEF2F2', dot: '#EF4444' },
  warning: { border: '#FCD34D', bg: '#FFFBEB', dot: '#F59E0B' },
  info:    { border: '#93C5FD', bg: '#EFF6FF', dot: '#3B82F6' },
};

export default function AdminPanel() {
  const navigate        = useNavigate();
  const { user, token } = useAuth();
  const [feed,          setFeed]         = useState([]);
  const [estado,        setEstado]       = useState(null);
  const [alertas,       setAlertas]      = useState([]);
  const [cargando,      setCargando]     = useState(true);
  const [notificando,   setNotificando]  = useState(null);
  const [ultimaActualizacion, setUltimaActualizacion] = useState(null);
  const [moderacion,    setModeracion]   = useState([]);
  const [sinCelular,    setSinCelular]   = useState([]);
  const [deportes,      setDeportes]     = useState([]);
  const [tabDerecha,    setTabDerecha]   = useState('alertas');
  const [modalBloqueo,  setModalBloqueo] = useState(null);
  const [motivoBloqueo, setMotivoBloqueo] = useState('');

  useEffect(() => {
    if (user && user.email !== ADMIN_EMAIL) navigate('/app/dashboard');
  }, [user]);

  const cargarDatos = useCallback(async () => {
    try {
      const [feedRes, estadoRes, alertasRes, modRes, sinCelRes, depRes] = await Promise.all([
        fetch(`${API}/api/admin/feed?limit=30`, { headers: { Authorization: `Bearer ${token}` } }),
        fetch(`${API}/api/admin/estado`,        { headers: { Authorization: `Bearer ${token}` } }),
        fetch(`${API}/api/admin/alertas`,       { headers: { Authorization: `Bearer ${token}` } }),
        fetch(`${API}/api/admin/usuarios-moderacion`,    { headers: { Authorization: `Bearer ${token}` } }),
        fetch(`${API}/api/admin/usuarios-sin-celular`,   { headers: { Authorization: `Bearer ${token}` } }),
        fetch(`${API}/api/admin/resumen-deportes`,       { headers: { Authorization: `Bearer ${token}` } }),
      ]);
      const [feedData, estadoData, alertasData, modData, sinCelData, depData] = await Promise.all([
        feedRes.json(), estadoRes.json(), alertasRes.json(), modRes.json(), sinCelRes.json(), depRes.json(),
      ]);
      if (Array.isArray(feedData))            setFeed(feedData);
      if (estadoData && !estadoData.error)    setEstado(estadoData);
      if (Array.isArray(alertasData))         setAlertas(alertasData);
      if (Array.isArray(modData))             setModeracion(modData);
      if (Array.isArray(sinCelData))          setSinCelular(sinCelData);
      if (Array.isArray(depData))             setDeportes(depData);
      setUltimaActualizacion(new Date());
    } catch (e) {
      console.error('Error cargando admin:', e);
    } finally {
      setCargando(false);
    }
  }, [token]);

  useEffect(() => {
    if (!token) return;
    cargarDatos();
    const i = setInterval(cargarDatos, 30000);
    return () => clearInterval(i);
  }, [cargarDatos]);

  const notificar = async (tipo, ids) => {
    setNotificando(tipo + JSON.stringify(ids));
    try {
      await fetch(`${API}/api/admin/notificar`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ tipo, ...ids }),
      });
      alert('✅ WhatsApp enviado');
    } catch { alert('❌ Error al notificar'); }
    finally { setNotificando(null); }
  };

  const ejecutarBloqueo = async (bloquear) => {
    if (!modalBloqueo) return;
    try {
      await fetch(`${API}/api/admin/usuarios/${modalBloqueo.usuario_id}/bloqueo`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ bloqueado: bloquear, motivo: motivoBloqueo }),
      });
      setModeracion(prev => prev.map(m =>
        m.usuario_id === modalBloqueo.usuario_id
          ? { ...m, bloqueado: bloquear, semaforo: bloquear ? 'bloqueado' : 'verde' }
          : m
      ));
      setModalBloqueo(null);
      setMotivoBloqueo('');
    } catch {
      alert('❌ Error al actualizar bloqueo');
    }
  };

  if (cargando) {
    return (
      <div style={styles.pagina}>
        <div style={styles.loadingWrap}>
          <div style={styles.loadingDot} />
          <span style={styles.loadingText}>Cargando panel admin...</span>
        </div>
      </div>
    );
  }

  const alertasUrgentes = alertas.filter(a => a.nivel === 'urgente').length;

  return (
    <div style={styles.pagina}>

      {/* Header */}
      <div style={styles.header}>
        <div style={styles.headerLeft}>
          <div style={styles.headerLogo}>
            Tu<span style={{ color: '#FF6B1A' }}>Rival</span>
            <span style={styles.headerBadge}>Admin</span>
          </div>
          <div style={styles.headerSub}>
            {new Date().toLocaleDateString('es-CL', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })}
            {ultimaActualizacion && (
              <span style={styles.headerUpdate}>
                · actualizado {ultimaActualizacion.toLocaleTimeString('es-CL', { hour: '2-digit', minute: '2-digit' })}
              </span>
            )}
          </div>
        </div>
        <div style={styles.liveBadge}>
          <div style={styles.liveDot} />
          En vivo · c/30s
        </div>
      </div>

      {/* Métricas */}
      {estado && (
        <div style={styles.metricsRow}>
          {[
            { label: 'Usuarios',        val: estado.usuarios,         sub: 'registrados',    color: '#1A6BFF' },
            { label: 'Equipos',         val: estado.equipos,          sub: 'activos',         color: '#16A34A' },
            { label: 'Desafíos semana', val: estado.desafios_semana,  sub: `ant: ${estado.desafios_semana_ant}`, color: '#7C3AED' },
            { label: 'Aceptación',      val: `${estado.tasa_aceptacion}%`, sub: 'esta semana', color: '#F59E0B' },
            { label: 'Alertas',         val: alertas.length,          sub: `${alertasUrgentes} urgentes`, color: alertasUrgentes > 0 ? '#EF4444' : '#6B7280' },
            { label: 'En línea',        val: estado.online_total,     sub: `${estado.online_apk} APK · ${estado.online_web} web`, color: '#16A34A' },
          ].map(m => (
            <div key={m.label} style={styles.metricCard}>
              <div style={{ ...styles.metricAccent, background: m.color }} />
              <div style={styles.metricLabel}>{m.label}</div>
              <div style={{ ...styles.metricVal, color: m.color }}>{m.val}</div>
              <div style={styles.metricSub}>{m.sub}</div>
            </div>
          ))}
        </div>
      )}

      {/* Body */}
      <div style={styles.body}>

        {/* Feed */}
        <div style={styles.feedCard}>
          <div style={styles.cardHeader}>
            <span style={styles.cardTitle}>⚡ Actividad en tiempo real</span>
            <span style={styles.cardCount}>{feed.length} eventos</span>
          </div>
          <div style={styles.feed}>
            {feed.length === 0 && (
              <div style={styles.empty}>Sin actividad reciente</div>
            )}
            {feed.map(ev => {
              const cfg  = TIPO_CONFIG[ev.tipo] || { icon: '·', color: '#6B7280', bg: 'rgba(107,114,128,0.1)' };
              const meta = ev.metadata || {};
              return (
                <div key={ev.id} style={styles.feedItem}>
                  <div style={{ ...styles.feedDot, background: cfg.bg }}>
                    <span style={{ color: cfg.color, fontSize: 12 }}>{cfg.icon}</span>
                  </div>
                  <div style={styles.feedContent}>
                    <div style={styles.feedDesc}>{ev.descripcion}
                      {meta.dispositivo && (
                        <span style={{ ...styles.pill, background: meta.dispositivo === 'apk' ? 'rgba(124,58,237,0.12)' : 'rgba(26,107,255,0.12)', color: meta.dispositivo === 'apk' ? '#7C3AED' : '#1A6BFF' }}>
                          {meta.dispositivo.toUpperCase()}
                        </span>
                      )}
                    </div>
                    {(meta.ciudad || meta.ip) && (
                      <div style={styles.feedMeta}>
                        {meta.ciudad && `📍 ${meta.ciudad}`}
                        {meta.ip && ` · ${meta.ip}`}
                      </div>
                    )}
                  </div>
                  <div style={styles.feedTime}>{formatTiempo(ev.creado_en)}</div>
                </div>
              );
            })}
          </div>
        </div>

        {/* Derecha */}
        <div style={styles.rightCol}>

          {/* Tabs */}
          <div style={styles.tabsRow}>
            {[
              { id: 'alertas',     label: '🔔 Alertas',     count: alertas.length },
              { id: 'moderacion',  label: '⚖️ Moderación',   count: moderacion.filter(m => m.semaforo === 'rojo' || m.semaforo === 'amarillo').length },
              { id: 'celular',     label: '📵 Sin celular',  count: sinCelular.length },
              { id: 'deportes',    label: '🎾 Deportes',     count: null },
              { id: 'facturacion', label: '💰 Facturación',  count: null },
            ].map(tab => (
              <button
                key={tab.id}
                onClick={() => setTabDerecha(tab.id)}
                style={{
                  ...styles.tabBtn,
                  background: tabDerecha === tab.id ? '#0D1117' : 'white',
                  color: tabDerecha === tab.id ? 'white' : '#6B7280',
                }}
              >
                {tab.label}
                {tab.count > 0 && (
                  <span style={{
                    ...styles.tabCount,
                    background: tabDerecha === tab.id ? 'rgba(255,255,255,0.2)' : '#FEE2E2',
                    color: tabDerecha === tab.id ? 'white' : '#DC2626',
                  }}>{tab.count}</span>
                )}
              </button>
            ))}
          </div>

          {/* Alertas */}
          {tabDerecha === 'alertas' && (
          <div style={styles.alertCard}>
            <div style={styles.cardHeader}>
              <span style={styles.cardTitle}>🔔 Alertas</span>
              {alertas.length > 0 && (
                <span style={{ ...styles.cardCount, background: '#FEE2E2', color: '#DC2626' }}>
                  {alertas.length}
                </span>
              )}
            </div>
            {alertas.length === 0 && <div style={styles.empty}>Sin alertas activas ✓</div>}
            {alertas.map((a, i) => {
              const c = NIVEL_COLORS[a.nivel] || NIVEL_COLORS.info;
              return (
                <div key={i} style={{ ...styles.alertItem, borderColor: c.border, background: c.bg }}>
                  <div style={styles.alertTop}>
                    <div style={styles.alertDotWrap}>
                      <div style={{ ...styles.alertDot, background: c.dot }} />
                      <span style={styles.alertTitle}>{a.titulo}</span>
                    </div>
                    <span style={styles.alertTime}>{a.tiempo}</span>
                  </div>
                  <div style={styles.alertBody}>{a.cuerpo}</div>
                  {(a.tipo === 'resultado_pendiente' || a.tipo === 'eval_pendiente') && (
                    <div style={styles.alertBtns}>
                      <button
                        style={styles.alertBtn}
                        onClick={() => notificar(
                          a.tipo,
                          a.tipo === 'resultado_pendiente'
                            ? { desafio_id: a.desafio_id }
                            : { partido_id: a.partido_id }
                        )}
                        disabled={!!notificando}
                      >
                        {notificando ? '...' : '📲 Notificar WSP'}
                      </button>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
          )}

          {/* Moderación */}
          {tabDerecha === 'moderacion' && (
            <div style={styles.alertCard}>
              <div style={styles.cardHeader}>
                <span style={styles.cardTitle}>⚖️ Moderación de equipos</span>
                <span style={styles.cardCount}>{moderacion.length}</span>
              </div>
              {moderacion.length === 0 && <div style={styles.empty}>Sin datos de evaluación aún</div>}
              {moderacion.map(m => {
                const semaforoColor = {
                  verde: '#16A34A', amarillo: '#F59E0B', rojo: '#EF4444', bloqueado: '#6B7280',
                }[m.semaforo];
                const semaforoLabel = {
                  verde: '🟢 OK', amarillo: '🟡 Atención', rojo: '🔴 Crítico', bloqueado: '⛔ Bloqueado',
                }[m.semaforo];
                return (
                  <div key={m.equipo_id} style={{ ...styles.modItem, borderLeftColor: semaforoColor }}>
                    <div style={styles.modTop}>
                      <span style={styles.modNombre}>{m.equipo_nombre}</span>
                      <span style={{ ...styles.modBadge, color: semaforoColor }}>{semaforoLabel}</span>
                    </div>
                    <div style={styles.modSub}>
                      {m.capitan_nombre} · {m.deporte} · ⭐ {m.promedio || '—'} ({m.total_evaluaciones} eval.)
                      {parseInt(m.negativas_30d) > 0 && ` · ${m.negativas_30d} neg. 30d`}
                    </div>
                    {(m.semaforo === 'rojo' || m.semaforo === 'amarillo' || m.bloqueado) && (
                      <button
                        style={{ ...styles.alertBtn, marginTop: 6, color: m.bloqueado ? '#16A34A' : '#EF4444' }}
                        onClick={() => setModalBloqueo(m)}
                      >
                        {m.bloqueado ? '✓ Desbloquear' : '⛔ Bloquear capitán'}
                      </button>
                    )}
                  </div>
                );
              })}
            </div>
          )}

          {/* Sin celular */}
          {tabDerecha === 'celular' && (
            <div style={styles.alertCard}>
              <div style={styles.cardHeader}>
                <span style={styles.cardTitle}>📵 Usuarios sin celular</span>
                <span style={styles.cardCount}>{sinCelular.length}</span>
              </div>
              {sinCelular.length === 0 && <div style={styles.empty}>Todos tienen celular ✓</div>}
              {sinCelular.map(u => (
                <div key={u.id} style={styles.modItem}>
                  <div style={styles.modTop}>
                    <span style={styles.modNombre}>{u.nombre}</span>
                  </div>
                  <div style={styles.modSub}>
                    {u.email} · {(u.deportes || []).filter(Boolean).join(', ') || 'sin equipo'}
                  </div>
                  <div style={{ fontSize: 10, color: '#EF4444', marginTop: 4 }}>
                    ⚠️ No recibirá notificaciones WhatsApp
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* Resumen por deporte */}
          {tabDerecha === 'deportes' && (
            <div style={styles.alertCard}>
              <div style={styles.cardHeader}>
                <span style={styles.cardTitle}>🎾 Resumen por deporte</span>
              </div>
              {deportes.length === 0 && <div style={styles.empty}>Sin datos aún</div>}
              {deportes.map(d => {
                const icono = d.deporte === 'futbol' ? '⚽' : '🎾';
                return (
                  <div key={d.deporte} style={styles.deporteRow}>
                    <div style={styles.deporteNombre}>{icono} {d.deporte}</div>
                    <div style={styles.deporteStats}>
                      <span>{d.equipos} equipos</span>
                      <span>{d.desafios_semana} desafíos/sem</span>
                      <span>ELO ~{d.elo_promedio}</span>
                    </div>
                  </div>
                );
              })}
            </div>
          )}

          {/* Facturación — placeholder */}
          {tabDerecha === 'facturacion' && (
            <div style={styles.alertCard}>
              <div style={styles.cardHeader}>
                <span style={styles.cardTitle}>💰 Facturación</span>
              </div>
              <div style={{ padding: '32px 16px', textAlign: 'center' }}>
                <div style={{ fontSize: 32, marginBottom: 8 }}>🚧</div>
                <div style={{ fontSize: 13, fontWeight: 700, color: '#141922', marginBottom: 4 }}>
                  Próximamente
                </div>
                <div style={{ fontSize: 11, color: '#9BA5B7', lineHeight: 1.5 }}>
                  La integración de pagos por desafío<br/>estará disponible cuando se<br/>active la pasarela Khipu.
                </div>
              </div>
            </div>
          )}

          {/* Estado */}
          {estado && (
            <div style={styles.estadoCard}>
              <div style={styles.cardHeader}>
                <span style={styles.cardTitle}>📊 Estado ahora</span>
              </div>
              {[
                { label: 'En línea',               val: `${estado.online_total}`,          danger: false },
                { label: 'APK / Web',              val: `${estado.online_apk} · ${estado.online_web}`, danger: false },
                { label: 'Desafíos pendientes',    val: estado.desafios_pendientes,        danger: false },
                { label: 'Sin resultado',          val: estado.alertas_resultado,          danger: estado.alertas_resultado > 0 },
                { label: 'Sin evaluación',         val: estado.alertas_eval,               warning: estado.alertas_eval > 0 },
                { label: 'Árbitros disponibles',   val: estado.arbitros_disponibles,       danger: false },
                { label: 'Deporte más activo',     val: estado.deporte_activo,             danger: false },
                { label: 'Zona más activa',        val: estado.zona_activa,                danger: false },
                { label: 'ELO promedio',           val: estado.elo_promedio,               danger: false },
              ].map(s => (
                <div key={s.label} style={styles.estadoRow}>
                  <span style={styles.estadoLabel}>{s.label}</span>
                  <span style={{
                    ...styles.estadoVal,
                    color: s.danger ? '#EF4444' : s.warning ? '#F59E0B' : '#141922',
                    fontWeight: (s.danger || s.warning) ? 700 : 500,
                  }}>{s.val}</span>
                </div>
              ))}
            </div>
          )}

          {/* Stats semana */}
          {estado && (
            <div style={styles.statsCard}>
              <div style={styles.cardHeader}>
                <span style={styles.cardTitle}>📈 Esta semana</span>
              </div>
              <div style={styles.statsGrid}>
                {[
                  { label: 'Desafíos',   val: estado.desafios_semana,    color: '#7C3AED' },
                  { label: 'Aceptación', val: `${estado.tasa_aceptacion}%`, color: '#16A34A' },
                ].map(s => (
                  <div key={s.label} style={styles.statItem}>
                    <div style={{ ...styles.statVal, color: s.color }}>{s.val}</div>
                    <div style={styles.statLabel}>{s.label}</div>
                  </div>
                ))}
              </div>
            </div>
          )}

        </div>
      </div>

      {/* Modal bloqueo/desbloqueo */}
      {modalBloqueo && (
        <div style={styles.modalOverlay} onClick={() => setModalBloqueo(null)}>
          <div style={styles.modal} onClick={e => e.stopPropagation()}>
            <div style={styles.modalTitulo}>
              {modalBloqueo.bloqueado ? '✓ Desbloquear capitán' : '⛔ Bloquear capitán'}
            </div>
            <div style={styles.modalSub}>
              {modalBloqueo.capitan_nombre} — {modalBloqueo.equipo_nombre}
            </div>
            {!modalBloqueo.bloqueado && (
              <div style={{ marginBottom: 16 }}>
                <div style={styles.modalLabel}>Motivo del bloqueo</div>
                <textarea
                  style={styles.modalTextarea}
                  rows={3}
                  placeholder="Ej: Acumulación de evaluaciones negativas por mal comportamiento"
                  value={motivoBloqueo}
                  onChange={e => setMotivoBloqueo(e.target.value)}
                />
              </div>
            )}
            <div style={{ display: 'flex', gap: 8 }}>
              <button style={styles.btnModalCancelar} onClick={() => setModalBloqueo(null)}>
                Cancelar
              </button>
              <button
                style={{
                  ...styles.btnModalConfirmar,
                  background: modalBloqueo.bloqueado ? '#16A34A' : '#EF4444',
                }}
                onClick={() => ejecutarBloqueo(!modalBloqueo.bloqueado)}
              >
                {modalBloqueo.bloqueado ? 'Confirmar desbloqueo' : 'Confirmar bloqueo'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const styles = {
  pagina:        { minHeight: '100vh', background: '#F0F2F5', fontFamily: "'Barlow', sans-serif" },
  loadingWrap:   { display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', gap: 12 },
  loadingDot:    { width: 8, height: 8, borderRadius: '50%', background: '#FF6B1A', animation: 'pulse 1s infinite' },
  loadingText:   { fontSize: 14, color: '#6B7280' },

  header: {
    background: '#0D1117', padding: '14px 24px',
    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
    borderBottom: '1px solid rgba(255,255,255,0.06)',
  },
  headerLeft:   {},
  headerLogo:   { fontFamily: "'Barlow Condensed', sans-serif", fontSize: 22, fontWeight: 800, color: 'white', display: 'flex', alignItems: 'center', gap: 8 },
  headerBadge:  { background: '#FF6B1A', color: 'white', fontSize: 10, fontWeight: 700, padding: '2px 8px', borderRadius: 20, letterSpacing: '0.05em' },
  headerSub:    { fontSize: 11, color: 'rgba(255,255,255,0.35)', marginTop: 3 },
  headerUpdate: { color: 'rgba(255,255,255,0.2)' },
  liveBadge:    { background: 'rgba(34,197,94,0.12)', color: '#4ADE80', fontSize: 11, padding: '4px 12px', borderRadius: 20, display: 'flex', alignItems: 'center', gap: 6, border: '1px solid rgba(74,222,128,0.2)' },
  liveDot:      { width: 6, height: 6, borderRadius: '50%', background: '#4ADE80' },

  metricsRow: {
    display: 'grid', gridTemplateColumns: 'repeat(6,1fr)',
    gap: 8, padding: '12px 24px',
    background: 'white', borderBottom: '1px solid #E8ECF4',
  },
  metricCard:   { background: '#F8FAFC', borderRadius: 10, padding: '10px 14px', position: 'relative', overflow: 'hidden' },
  metricAccent: { position: 'absolute', top: 0, left: 0, right: 0, height: 3, borderRadius: '10px 10px 0 0' },
  metricLabel:  { fontSize: 10, color: '#6B7280', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 4, marginTop: 4 },
  metricVal:    { fontSize: 22, fontWeight: 800, fontFamily: "'Barlow Condensed', sans-serif", lineHeight: 1 },
  metricSub:    { fontSize: 10, color: '#9BA5B7', marginTop: 3 },

  body: { display: 'grid', gridTemplateColumns: '1fr 300px', gap: 16, padding: '16px 24px' },

  feedCard: { background: 'white', borderRadius: 12, border: '1px solid #E8ECF4', overflow: 'hidden' },
  cardHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 16px', borderBottom: '1px solid #F0F2F5' },
  cardTitle:  { fontSize: 12, fontWeight: 700, color: '#141922', textTransform: 'uppercase', letterSpacing: '0.05em' },
  cardCount:  { background: '#F0F2F5', color: '#6B7280', fontSize: 10, fontWeight: 600, padding: '2px 8px', borderRadius: 10 },

  feed:       { padding: '8px 0', maxHeight: 600, overflowY: 'auto' },
  feedItem:   { display: 'flex', alignItems: 'flex-start', gap: 10, padding: '8px 16px', borderBottom: '1px solid #F8FAFC' },
  feedDot:    { width: 28, height: 28, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, marginTop: 1 },
  feedContent:{ flex: 1 },
  feedDesc:   { fontSize: 12, color: '#141922', lineHeight: 1.5 },
  feedMeta:   { fontSize: 11, color: '#9BA5B7', marginTop: 2 },
  feedTime:   { fontSize: 10, color: '#C4C9D4', flexShrink: 0, marginTop: 2, whiteSpace: 'nowrap' },
  pill:       { display: 'inline-block', fontSize: 9, fontWeight: 700, padding: '1px 6px', borderRadius: 6, marginLeft: 5, verticalAlign: 'middle' },

  rightCol:   { display: 'flex', flexDirection: 'column', gap: 12 },

  alertCard:  { background: 'white', borderRadius: 12, border: '1px solid #E8ECF4', overflow: 'hidden' },
  alertItem:  { margin: '8px 12px', borderRadius: 10, border: '1.5px solid', padding: '10px 12px' },
  alertTop:   { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 },
  alertDotWrap: { display: 'flex', alignItems: 'center', gap: 6 },
  alertDot:   { width: 7, height: 7, borderRadius: '50%', flexShrink: 0 },
  alertTitle: { fontSize: 11, fontWeight: 700, color: '#141922' },
  alertTime:  { fontSize: 10, color: '#9BA5B7', flexShrink: 0 },
  alertBody:  { fontSize: 11, color: '#4B5563', lineHeight: 1.4 },
  alertBtns:  { marginTop: 8 },
  alertBtn:   { fontSize: 11, padding: '4px 10px', borderRadius: 6, border: '1px solid #E8ECF4', background: 'white', cursor: 'pointer', fontFamily: "'Barlow', sans-serif", fontWeight: 600 },

  estadoCard: { background: 'white', borderRadius: 12, border: '1px solid #E8ECF4', overflow: 'hidden' },
  estadoRow:  { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '6px 16px', borderBottom: '1px solid #F8FAFC' },
  estadoLabel:{ fontSize: 11, color: '#6B7280' },
  estadoVal:  { fontSize: 12 },

  statsCard:  { background: 'white', borderRadius: 12, border: '1px solid #E8ECF4', overflow: 'hidden' },
  statsGrid:  { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 1, padding: '12px 16px' },
  statItem:   { textAlign: 'center', padding: '8px 0' },
  statVal:    { fontSize: 26, fontWeight: 800, fontFamily: "'Barlow Condensed', sans-serif", lineHeight: 1 },
  statLabel:  { fontSize: 10, color: '#9BA5B7', marginTop: 3, textTransform: 'uppercase', letterSpacing: '0.04em' },

  empty: { padding: '20px 16px', textAlign: 'center', color: '#C4C9D4', fontSize: 12 },

  tabsRow: { display: 'flex', flexWrap: 'wrap', gap: 6 },
  tabBtn: {
    display: 'flex', alignItems: 'center', gap: 6,
    fontSize: 10, fontWeight: 700, padding: '6px 10px',
    borderRadius: 8, border: '1px solid #E8ECF4', cursor: 'pointer',
    fontFamily: "'Barlow', sans-serif",
  },
  tabCount: {
    fontSize: 9, fontWeight: 800, padding: '1px 6px', borderRadius: 10,
  },

  modItem: {
    margin: '8px 12px', borderRadius: 10, border: '1px solid #E8ECF4',
    borderLeft: '3px solid #E8ECF4', padding: '10px 12px',
  },
  modTop: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 3 },
  modNombre: { fontSize: 12, fontWeight: 700, color: '#141922' },
  modBadge: { fontSize: 10, fontWeight: 700 },
  modSub: { fontSize: 11, color: '#6B7280', lineHeight: 1.4 },

  deporteRow: {
    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
    padding: '10px 16px', borderBottom: '1px solid #F8FAFC',
  },
  deporteNombre: { fontSize: 13, fontWeight: 700, color: '#141922', textTransform: 'capitalize' },
  deporteStats: { display: 'flex', gap: 10, fontSize: 10, color: '#6B7280' },

  modalOverlay: {
    position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    zIndex: 1000, padding: 20,
  },
  modal: {
    background: 'white', borderRadius: 16, padding: 24,
    width: '100%', maxWidth: 380,
  },
  modalTitulo: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 18, fontWeight: 800, color: '#141922', marginBottom: 4,
  },
  modalSub: { fontSize: 12, color: '#6B7280', marginBottom: 16 },
  modalLabel: {
    fontSize: 10, fontWeight: 700, color: '#6B7280',
    textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 6,
  },
  modalTextarea: {
    width: '100%', padding: '10px 12px', border: '1.5px solid #E8ECF4',
    borderRadius: 10, fontSize: 12, fontFamily: "'Barlow', sans-serif",
    resize: 'none', outline: 'none', boxSizing: 'border-box', color: '#141922',
  },
  btnModalCancelar: {
    flex: 1, padding: '10px', background: 'white', border: '1.5px solid #E8ECF4',
    borderRadius: 10, fontSize: 13, fontWeight: 700, color: '#6B7280', cursor: 'pointer',
    fontFamily: "'Barlow Condensed', sans-serif",
  },
  btnModalConfirmar: {
    flex: 2, padding: '10px', border: 'none', borderRadius: 10,
    fontSize: 13, fontWeight: 800, color: 'white', cursor: 'pointer',
    fontFamily: "'Barlow Condensed', sans-serif",
  },
};
